(() => {
  const q = (root, selector) => root.querySelector(selector);
  const qa = (root, selector) => Array.from(root.querySelectorAll(selector));
  const money = (cents) => {
    try { return new Intl.NumberFormat('en-GB', {style:'currency',currency:(window.Shopify && Shopify.currency && Shopify.currency.active)||'GBP'}).format(cents/100); }
    catch(e){ return `£${(cents/100).toFixed(2)}`; }
  };
  const iso = date => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  const weekend = date => date.getDay() === 0 || date.getDay() === 6;
  const parseCutoff = value => {
    const match = String(value || '17:30').match(/^(\d{1,2}):(\d{2})$/);
    const hour = match ? Math.min(23, Math.max(0, Number(match[1]))) : 17;
    const minute = match ? Math.min(59, Math.max(0, Number(match[2]))) : 30;
    return {hour, minute};
  };
  const nextWorkingOnOrAfter = (date, excluded) => {
    const d = new Date(date); d.setHours(12,0,0,0);
    while (weekend(d) || excluded.has(iso(d))) d.setDate(d.getDate()+1);
    return d;
  };
  const londonNowParts = () => {
    try {
      const parts = new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
      const value = type => Number(parts.find(part=>part.type===type)?.value);
      return {year:value('year'),month:value('month'),day:value('day'),hour:value('hour'),minute:value('minute')};
    } catch(e) {
      const now = new Date();
      return {year:now.getFullYear(),month:now.getMonth()+1,day:now.getDate(),hour:now.getHours(),minute:now.getMinutes()};
    }
  };
  const earliestDate = (excluded=new Set(), cutoffValue='17:30') => {
    const now = londonNowParts();
    let processing = new Date(now.year, now.month-1, now.day, 12, 0, 0, 0);
    const todayWorking = !weekend(processing) && !excluded.has(iso(processing));
    const cutoff = parseCutoff(cutoffValue);
    const afterCutoff = now.hour > cutoff.hour || (now.hour === cutoff.hour && now.minute >= cutoff.minute);
    if (!todayWorking || afterCutoff) {
      if (todayWorking && afterCutoff) processing.setDate(processing.getDate()+1);
      processing = nextWorkingOnOrAfter(processing, excluded);
    }
    const earliest = new Date(processing); earliest.setDate(earliest.getDate()+1);
    return nextWorkingOnOrAfter(earliest, excluded);
  };
  const parseRepairItem = form => {
    const fd = new FormData(form); const props = {}; let id=null, quantity=1, sellingPlan=null;
    fd.forEach((value,key) => {
      if (key === 'id') id = Number(value);
      else if (key === 'quantity') quantity = Math.max(1, Number(value)||1);
      else if (key === 'selling_plan' && value) sellingPlan = Number(value);
      else { const m = key.match(/^properties\[(.*)\]$/); if (m && value !== '') props[m[1]] = value; }
    });
    const item = {id, quantity, properties:props}; if (sellingPlan) item.selling_plan = sellingPlan; return item;
  };
  const sectionsForCart = drawer => {
    let sections='cart-icon-bubble';
    if (drawer && drawer.closest('.shopify-section')) sections += `,${drawer.closest('.shopify-section').id.replace('shopify-section-','')}`;
    return sections;
  };
  const renderCart = async data => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && data.sections) drawer.renderContents(data, true);
    else if (drawer) { await drawer.refresh(true); drawer.open(); }
    else if (window.location.pathname === (window.theme?.routes?.cart || '/cart')) window.location.reload();
    else document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
  };

  class RmxCollectionAddon extends HTMLElement {
    connectedCallback(){ if (this.dataset.initialized === 'true') return; this.dataset.initialized='true'; this.init(); }
    init(){
      this.mode=this.dataset.mode || 'cart'; this.toggle=q(this,'[data-rmx-ca-toggle]'); this.panel=q(this,'[data-rmx-ca-panel]'); this.enable=q(this,'[data-rmx-ca-enable]'); this.fields=q(this,'[data-rmx-ca-fields]'); this.confirmations=q(this,'[data-rmx-ca-confirmations]'); this.error=q(this,'[data-rmx-ca-error]'); this.submit=q(this,'[data-rmx-ca-submit]'); this.date=q(this,'[data-rmx-ca-date]'); this.excludedDates=new Set((this.dataset.excludedDates||'').split(',').map(v=>v.trim()).filter(Boolean)); this.cutoffTime=this.dataset.cutoffTime||'17:30';
      if(this.toggle) this.toggle.addEventListener('click',()=>this.togglePanel());
      if(this.enable) this.enable.addEventListener('change',()=>{ const on=this.enable.checked; if(this.fields)this.fields.hidden=!on; if(this.confirmations)this.confirmations.hidden=!on; this.setControlsEnabled(on); if(on){this.open();this.updateRepairButton(true);} else this.updateRepairButton(false); });
      if(this.date){ this.date.min=iso(earliestDate(this.excludedDates,this.cutoffTime)); this.date.addEventListener('change',()=>this.validateDate(true)); }
      if(this.submit) this.submit.addEventListener('click',()=>this.addCollectionOnly());
      if(this.mode==='standalone') this.setControlsEnabled(true);
      if(this.mode==='product'){
        const form=document.getElementById(this.dataset.repairFormId);
        if(form){ this.repairForm=form; form.addEventListener('submit',e=>this.interceptProductSubmit(e),true); }
      }
    }
    open(){ this.classList.add('is-open'); if(this.panel)this.panel.hidden=false; if(this.toggle)this.toggle.setAttribute('aria-expanded','true'); if(this.mode!=='product')this.setControlsEnabled(true); }
    close(){ if(this.mode==='product' && this.enable){this.enable.checked=false;this.updateRepairButton(false);} this.setControlsEnabled(false); this.classList.remove('is-open'); if(this.panel)this.panel.hidden=true; if(this.toggle)this.toggle.setAttribute('aria-expanded','false'); }
    togglePanel(){ this.classList.contains('is-open') ? this.close() : this.open(); }
    setControlsEnabled(on){ qa(this,'[data-rmx-ca-fields] input,[data-rmx-ca-fields] select,[data-rmx-ca-fields] textarea,[data-rmx-ca-confirmations] input').forEach(el=>{el.disabled=!on;}); }
    updateRepairButton(on){ if(!this.repairForm)return; this.repairForm.dataset.rmxCollectionEnabled=on?'true':'false'; this.repairForm.dispatchEvent(new CustomEvent('rmx:collection-toggle',{bubbles:true,detail:{enabled:on}})); }
    validateDate(report=false){ if(!this.date || !this.date.value) return false; const d=new Date(`${this.date.value}T12:00:00`); if(weekend(d) || this.excludedDates.has(this.date.value) || this.date.value < this.date.min){ this.date.setCustomValidity('Please choose an available collection date shown by the calendar.'); if(report)this.date.reportValidity(); return false; } this.date.setCustomValidity(''); return true; }
    collectionProperties(){
      const get = s => q(this,s)?.value?.trim() || '';
      return {
        '_Collection booking':'Yes',
        'Preferred collection date':get('[data-rmx-ca-date]'),
        'Company or garage':get('[data-rmx-ca-company]'),
        'Collection contact':get('[data-rmx-ca-contact]'),
        'Collection contact number':get('[data-rmx-ca-phone]'),
        'Part number':get('[data-rmx-ca-part-number]') || document.querySelector('[data-rmx-sku]')?.textContent?.trim() || this.dataset.productSku || '',
        'Part being collected':get('[data-rmx-ca-part]') || this.dataset.productTitle || '',
        'Collection notes':get('[data-rmx-ca-notes]'),
        'Collection address':'Address entered at checkout',
        'Packing slip confirmed':'Yes',
        'Packaging confirmed':'Yes',
        'Collection terms accepted':'Yes'
      };
    }
    validate(){
      if(this.mode==='product' && this.enable && !this.enable.checked) return true;
      this.open(); let ok=this.validateDate(false);
      qa(this,'[required]').forEach(el=>{ if(el.type==='checkbox'){ if(!el.checked)ok=false; } else if(!el.value.trim()) ok=false; });
      if(!ok){ if(this.error){this.error.textContent=this.dataset.requiredMessage || 'Please complete the collection details.';this.error.hidden=false;} const first=qa(this,'[required]').find(el=>(el.type==='checkbox'?!el.checked:!el.value.trim())); (first||this.date)?.focus(); return false; }
      if(this.error)this.error.hidden=true; return true;
    }
    collectionItem(){ return {id:Number(this.dataset.collectionVariantId),quantity:Math.max(1,Number(q(this,'[data-rmx-ca-parcels]')?.value)||1),properties:this.collectionProperties()}; }
    setLoading(button,on){ if(!button)return; button.toggleAttribute('aria-disabled',on); button.classList.toggle('is-loading',on); }
    async addItems(items,button){
      const drawer=document.querySelector('cart-drawer'); const body={items,sections:sectionsForCart(drawer),sections_url:window.location.pathname}; this.setLoading(button,true);
      try{
        const res=await fetch(window.theme?.routes?.cartAdd || '/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)}); const data=await res.json();
        if(!res.ok || data.status) throw new Error(data.description || data.message || 'Unable to add collection.');
        await renderCart(data); return true;
      }catch(err){ if(this.error){this.error.textContent=err.message || 'Unable to add collection.';this.error.hidden=false;} return false; }
      finally{this.setLoading(button,false);}
    }
    async addCollectionOnly(){ if(!this.validate())return; await this.addItems([this.collectionItem()],this.submit); }
    async interceptProductSubmit(event){
      if(!this.enable || !this.enable.checked) return;
      const button=q(this.repairForm,'[name="add"]');
      if(button && button.disabled) return;
      if(typeof this.repairForm.checkValidity==='function' && !this.repairForm.checkValidity()){ this.repairForm.reportValidity(); return; }
      event.preventDefault(); event.stopImmediatePropagation();
      if(!this.validate()) return;
      const repair=parseRepairItem(this.repairForm);
      if(!repair.id){ if(this.error){this.error.textContent='Choose the repair option before adding collection.';this.error.hidden=false;} return; }
      await this.addItems([repair,this.collectionItem()],button);
    }
  }
  if(!customElements.get('rmx-collection-addon')) customElements.define('rmx-collection-addon',RmxCollectionAddon);

  const initStatus = root => {
    qa(root,'[data-rmx-v11-status-button]').forEach(btn=>btn.addEventListener('click',()=>{
      const key=btn.dataset.rmxV11StatusButton;
      qa(root,'[data-rmx-v11-status-button]').forEach(b=>b.classList.toggle('is-active',b===btn));
      qa(root,'[data-rmx-v11-status-panel]').forEach(p=>p.classList.toggle('is-active',p.dataset.rmxV11StatusPanel===key));
    }));
  };
  document.querySelectorAll('[data-rmx-v11-status]').forEach(initStatus);
  document.addEventListener('shopify:section:load',e=>{ e.target.querySelectorAll('[data-rmx-v11-status]').forEach(initStatus); });
})();
